import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { ClassRecord } from '../../data/classes';
import { ClassCard } from './ClassCard';
interface DayClassesDrawerProps {
  date: string | null;
  classes: ClassRecord[];
  isOpen: boolean;
  onClose: () => void;
  onClassClick: (classRecord: ClassRecord) => void;
}
export function DayClassesDrawer({
  date,
  classes,
  isOpen,
  onClose,
  onClassClick
}: DayClassesDrawerProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!date) return null;
  const formattedDate = new Date(date + 'T00:00:00').toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return <AnimatePresence data-id="element-166" data-mp="hyv5gmtbs0ps">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/50 z-40 transition-opacity" aria-hidden="true" data-id="element-167" data-mp="hxabayaxajsg" />

          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-y-0 right-0 w-full max-w-md bg-gray-50 shadow-xl z-40 flex flex-col overflow-hidden" role="dialog" aria-modal="true" aria-labelledby="day-drawer-title" data-id="element-168" data-mp="3v6y8s8th5w4w">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-white" data-id="element-169" data-mp="pqvjku0agckk">
              <div data-id="element-170" data-mp="14oflfs1w1rmi">
                <h2 id="day-drawer-title" className="text-lg font-bold text-gray-900" data-id="element-171" data-mp="14mura3jhkap6">
                  Classes on
                </h2>
                <p className="text-sm text-brand-purple-600 font-medium" data-id="element-172" data-mp="byffdpvni8i2">
                  {formattedDate}
                </p>
              </div>
              <button onClick={onClose} className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-purple-500" aria-label="Close panel" data-id="element-173" data-mp="6y14m02o0kgc">
                <X className="w-5 h-5" data-id="element-174" data-mp="3pcttrxhrhrke" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-4" data-id="element-175" data-mp="3kfto3notqqtt">
              {classes.length === 0 ? <p className="text-gray-500 text-center py-8" data-id="element-176" data-mp="1zvy9m396xdt7">
                  No classes scheduled for this day.
                </p> : classes.map(cls => <ClassCard key={cls.id} classRecord={cls} onClick={c => {
            // We don't close this drawer, just open the detail drawer over it
            onClassClick(c);
          }} data-id="element-177" data-mp="1pzuxc4kmjysj" />)}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}